import { useLocation } from 'react-router-dom';
import TopNav from '@/components/TopNav';
import BottomNav from '@/components/BottomNav';
import { useAuth } from '@/App';

const HIDE_NAV_PATHS = ['/complete/', '/skill-assessment', '/rpl-assessment', '/skill-complete/', '/visa-review/'];

export default function AppShell({ children }) {
  const location = useLocation();
  const { user } = useAuth();
  const hideNav = HIDE_NAV_PATHS.some(p => location.pathname.startsWith(p));
  const isPublicAgentView = !user && (location.pathname.startsWith('/agents/') || location.pathname.startsWith('/university/'));

  return (
    <div className="min-h-screen bg-[#F7F9FC]">
      {!isPublicAgentView && <TopNav />}
      <main className="pb-safe">
        {children}
      </main>
      {!hideNav && !isPublicAgentView && <BottomNav />}
    </div>
  );
}
